import { gql } from '@apollo/client';

export const BuyerSellerRelationshipFragment = gql`
  fragment BuyerSellerRelationshipParts on BuyerSellerRelationshipType {
    id
    sellerSiteId
    buyerSiteId
    sellerUserEmails
    buyerUserEmails
  }
`;

export const SiteFragment = gql`
  fragment SiteFields on Site {
    _id
    siteName
    siteType
    siteRole
    itemImportSite
    fiscalYearStart
    physicalAddress {
      content
      loc {
        type
        coordinates
      }
      city
      streetAddress
      stateCode
      zipCode
      countryCode
    }
    tags
    itemImportEmailRecipients
    inventoryImportEmailRecipients
    defaultPricingStrategy
    defaultPricingPercentage
    awardSheetEmailTemplate
    archived
    subscriptionTier
    parentSite
    rootSite
    transactionServicesSettings {
      supportedLogisticsOptions
      paymentTerms
      pickupLeadTime
      channelRestrictions
      packingListContacts
      takeRate
      supplierPaymentDueDays
      buyerPaymentDueDays
      numocoCompanyId
      numocoAddressId
    }
    bestByDateType
  }
`;
